declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, SavePurchaseOrderRequest, PurchaseOrderItemRequest, SaveVendorInvoice, VendorInvoiceItemRequest, } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { Time } from '@angular/common';

@Component({
  selector: 'editPIitems2',
  templateUrl: './editPIitems2.modal.html',
  styleUrls: ['./editPIitems2.modal.scss']
})

export class NgbEditPIitems2Modal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  @Input() PurchaseInvoiceData: SaveVendorInvoice;
  @Input() PurchaseInvoiceItem: VendorInvoiceItemRequest;
  @Input() VendorName: string;
  @Input() OwnerStoreName: string;
  @Input() PurchaseOrderCode: string;
  @Input() ExpiryDate: NgbDateStruct;
  TodayDate = new Date();
  public UpdatedExpiryDate: NgbDateStruct;
  isRequesting: boolean;

  public SelectedDay: any;
  public SelectedMonth: any;
  public SelectedYear: any;
  SelectedFromDate: NgbDateStruct;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
    this.UpdatedExpiryDate = this.ExpiryDate;
    //this.SelectedDay = this.route.snapshot.paramMap.get('Day');
    //this.SelectedMonth = this.route.snapshot.paramMap.get('month');
    //this.SelectedYear = this.route.snapshot.paramMap.get('year');
    //this.SelectedFromDate = {
    //  year: this.SelectedYear,
    //  month: this.SelectedMonth,
    //  day: this.SelectedDay
    //};
    //this.PurchaseInvoiceItem.ExpiryDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  public CloseDialog() {
    this.PurchaseInvoiceItem.ExpiryDate = new Date(this.parserFormatter.format(this.UpdatedExpiryDate));
    this.activeModal.close(this.PurchaseInvoiceItem);
  }

}
